import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export function RefundIcon(props) {
	return (
		<SvgIcon {...props} viewBox="0 0 20 20" fill="none">
			<g clipPath="url(#clip0)">
				<path d="M10.8333 5.41663V14.5833" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
				<path d="M12.9167 7.08337H9.79168C9.4049 7.08337 9.03397 7.23702 8.76048 7.51051C8.48699 7.784 8.33334 8.15493 8.33334 8.54171C8.33334 8.92848 8.48699 9.29941 8.76048 9.5729C9.03397 9.8464 9.4049 10 9.79168 10H11.875C12.2618 10 12.6327 10.1537 12.9062 10.4272C13.1797 10.7007 13.3333 11.0716 13.3333 11.4584C13.3333 11.8451 13.1797 12.2161 12.9062 12.4896C12.6327 12.7631 12.2618 12.9167 11.875 12.9167H8.33334" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
			</g>
			<path d="M1.66666 5V8.33333H4.99999" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M3.75832 12.5C4.29865 14.0336 5.32277 15.3501 6.67637 16.2511C8.02997 17.1521 9.63973 17.5888 11.2631 17.4954C12.8864 17.4019 14.4355 16.7835 15.6768 15.7331C16.9181 14.6828 17.7844 13.2575 18.1452 11.6719C18.506 10.0864 18.3417 8.42661 17.6772 6.94256C17.0126 5.45851 15.8838 4.23064 14.4607 3.44395C13.0376 2.65726 11.3974 2.35436 9.78722 2.58091C8.17703 2.80745 6.68408 3.55116 5.53332 4.69998L1.66666 8.33331" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
			<defs>
				<clipPath id="clip0">
					<rect width="10" height="10" fill="white" transform="translate(5.83334 5)"/>
				</clipPath>
			</defs>
		</SvgIcon>
	);
}

export default RefundIcon;